import { Granularity } from 'types/contracts.ts'
import { AvailableMarketPriceGranularity } from './types.ts'

export const LOWEST_PRICES_HIGHLIGHTED_ENTRIES: Record<AvailableMarketPriceGranularity, number> = {
  [Granularity.HOUR]: 4,
  [Granularity.QUARTER_HOUR]: 4 * 4 // 4 quarters in 1 hour
}
